import axios from "axios";
import { API_BASE } from "../config/constants";

export const executiveProgramResource = axios.create({
  baseURL: `${API_BASE}/api/v1/executive-program`,
});

export const executivePackagesResource = (url, eventId) =>
  axios.create({
    baseURL: `${url}/api/external/sponsorship/${eventId}`,
  });
